/**
 * 路由树配置
 * 统一管理项目的静态路由结构
 */

/**
 * 路由配置项
 * @typedef {Object} RouteConfig
 * @property {string} path - 路由路径（不包含 locale）
 * @property {string} name - 路由名称
 * @property {string} component - 组件路径（相对于 src/views）
 * @property {string} titleKey - i18n 标题 key
 * @property {string} navKey - i18n 导航 key（可选，用于导航栏显示）
 * @property {boolean} showInNav - 是否在导航栏显示（默认 true）
 * @property {Object} meta - 路由元信息
 */

/**
 * 主布局的子路由配置,如果新增了路由,请在这里添加，并且需要更新vue.config.js中的sitemapWebpackPlugin配置
 */
export const layoutChildren = [
	{
		path: '/',
		name: 'Home',
		component: 'Home',
		titleKey: 'pages.home.title',
		navKey: 'nav.home',
		showInNav: true,
		meta: {}
	},
	{
		path: 'financials',
		name: 'Financials',
		component: 'Financials',
		titleKey: 'pages.financials.title',
		navKey: 'nav.financials',
		showInNav: true,
		meta: {
			navKey: 'nav.financials'
		}
	},
	{
		path: 'filings',
		name: 'Filings',
		component: 'Filings',
		titleKey: 'pages.filings.title',
		navKey: 'nav.filings',
		showInNav: true,
		meta: {
			navKey: 'nav.filings'
		}
	},
	{
		path: 'news-events',
		name: 'NewsEvents',
		component: 'NewsEvents',
		titleKey: 'pages.newsEvents.title',
		navKey: 'nav.newsEvents',
		showInNav: true,
		meta: {
			navKey: 'nav.newsEvents'
		}
	},
	{
		path: 'corporate-governance',
		name: 'CorporateGovernance',
		component: 'CorporateGovernance',
		titleKey: 'pages.corporateGovernance.title',
		navKey: 'nav.corporateGovernance',
		showInNav: true,
		meta: {
			navKey: 'nav.corporateGovernance'
		}
	},
	{
		path: 'investor-tools',
		name: 'InvestorTools',
		component: 'InvestorTools',
		titleKey: 'pages.investorTools.title',
		navKey: 'nav.investorTools',
		showInNav: true,
		meta: {
			navKey: 'nav.investorTools'
		}
	}
];

/**
 * 获取导航栏路由配置（过滤掉不在导航栏显示的路由）
 * @returns {RouteConfig[]} 导航栏路由配置数组
 */
export function getNavRoutes() {
	return layoutChildren.filter(route => route.showInNav !== false);
}

/**
 * 将路由配置转换为 Vue Router 路由对象
 * @param {RouteConfig[]} routes - 路由配置数组
 * @returns {Array} Vue Router 路由对象数组
 */
export function buildRoutes(routes) {
	return routes.map(route => {
		const routeConfig = {
			path: route.path,
			name: route.name,
			component: () => import(`@/views/${route.component}.vue`),
			meta: {
				titleKey: route.titleKey,
				...route.meta
			}
		};

		return routeConfig;
	});
}

/**
 * 获取主布局的子路由
 * @returns {Array} Vue Router 路由对象数组
 */
export function getLayoutChildren() {
	const routeTree = buildRoutes(layoutChildren);
	console.log('😪 # getLayoutChildren # routeTree:', routeTree);
	return routeTree;
}
